import React from "react";
import "../style/newspage.css";
import newsData from "../data/newsData.json";
import broadcrypto from "../assets/broadcrypto.webp";
import ethereum from "../assets/ethereum.webp";
import xrp from "../assets/xrp.webp";
import kucoin from "../assets/kucoin.webp";
import nativeamericas from "../assets/nativeamericas.webp";
import sp from "../assets/s&p.webp";
import ad1 from "../assets/300x250px.webp";
import ad2 from "../assets/300x600.webp";

const imageMap = {
    "broadcrypto.webp": broadcrypto,
    "ethereum.webp": ethereum,
    "xrp.webp": xrp,
    "kucoin.webp": kucoin,
  "nativeamericas.webp": nativeamericas,
  "s&p.webp": sp
};

export default function NewsPage() {
 return (
  <div className="page-container">
    {/* LEFT COLUMN */}
    <div className="news-column">

      {/* FEATURED STORY */}
      <section className="featured">
        <div className="featured-content">
          <span className="featured-badge">Featured</span>
          <h2>Crypto Market Braces for Volatility Ahead of Fed Decision</h2>
          <p>
            Bitcoin and Ethereum traders are positioning cautiously as global
            macro events could shake markets this week.
          </p>
        </div>
      </section>

      {/* TRENDING TOPICS */}
      <section className="trending">
        <h3>Trending Topics</h3>
        <div className="tags">
          <span>#Bitcoin</span>
          <span>#Ethereum</span>
          <span>#DeFi</span>
          <span>#Web3</span>
          <span>#Altcoins</span>
        </div>
      </section>

      {/* MARKET SNAPSHOT */}
      <section className="market-snapshot">
        <div className="snapshot-card">
          <h4>BTC</h4>
          <p>$43,210</p>
          <span className="green">+2.4%</span>
        </div>
        <div className="snapshot-card">
          <h4>ETH</h4>
          <p>$2,310</p>
          <span className="red">-1.1%</span>
        </div>
        <div className="snapshot-card">
          <h4>Market Cap</h4>
          <p>$1.62T</p>
        </div>
      </section>

      {/* EDITORS PICK */}
      <section className="editors-pick">
        <h2 className="news-heading">Editor’s Picks</h2>
        {newsData.slice(0, 2).map((item, i) => (
          <div className="news-item" key={i}>
            <div className="news-meta">{item.date}</div>
            <h3 className="news-title">{item.title}</h3>
            <div className="news-row">
              <p className="news-description">{item.description}</p>
              <img
                src={imageMap[item.image]}
                alt="thumb"
                className="news-thumb"
              />
            </div>
          </div>
        ))}
      </section>

      {/* ALL NEWS */}
      <h1 className="news-heading">Latest News</h1>
      {newsData.map((item, i) => (
        <div className="news-item" key={i}>
          <div className="news-meta">{item.date}</div>
          <h3 className="news-title">{item.title}</h3>
          <div className="news-row">
            <p className="news-description">{item.description}</p>
            <img
              src={imageMap[item.image]}
              alt="thumb"
              className="news-thumb"
            />
          </div>
        </div>
      ))}
    </div>

    {/* RIGHT COLUMN */}
    <div className="ads-column">
      <div className="ad-box">
        <img src={ad1} alt="ad" />
      </div>
      <div className="ad-box">
        <img src={ad2} alt="ad" />
      </div>
    </div>
  </div>
);
}
